import React, { memo } from "react";

interface ReportDetailRowProps {
  label: string;
  value: string | number;
  onClick?: () => void;
  clickable?: boolean;
}

const ReportDetailRow: React.FC<ReportDetailRowProps> = memo(
  ({ label, value, onClick, clickable = false }) => {
    return (
      <div className="detail-row">
        <span className="detail-label">{label}:</span>
        {clickable && onClick ? (
          <button className="detail-value-button" onClick={onClick}>
            {value}
          </button>
        ) : (
          <span className="detail-value">{value}</span>
        )}
      </div>
    );
  }
);

ReportDetailRow.displayName = "ReportDetailRow";

export default ReportDetailRow;
